<template>
  <div class="auth-login__checkbox-field">
    <label
      class="auth-login__checkbox"
      :class="{ 'auth-login__checkbox--multiline': $slots.default, 'auth-login__checkbox--error': error }"
      :for="id"
    >
      <input
        :id="id"
        type="checkbox"
        :checked="modelValue"
        :aria-invalid="error ? 'true' : undefined"
        :aria-describedby="error ? `${id}-error` : undefined"
        @change="emit('update:modelValue', $event.target.checked)"
      />
      <span v-if="$slots.default"><slot /></span>
      <span v-else>{{ label }}</span>
    </label>
    <span v-if="error" :id="`${id}-error`" class="auth-login__error" role="alert">{{ error }}</span>
  </div>
</template>

<script setup>
defineProps({
  id:         { type: String, required: true },
  modelValue: { type: Boolean, default: false },
  label:      { type: String, default: '' },
  error:      { type: String, default: '' },
})

const emit = defineEmits(['update:modelValue'])
</script>
